module.exports = __webpack_public_path__ + "static/Fabriga-Regular-7db040300ee4da814e50680ca676f059.woff2";